export default {
  Title: 'Contact Information',
  Subtitle: 'Provide your contact details for communication and scheduling',
  FirstNameLabel: 'First Name *',
  LastNameLabel: 'Last Name *',
  EmailLabel: 'Email Address *',
  PhoneLabel: 'Phone Number *',
  StreetAddressLabel: 'Street Address *',
  CityLabel: 'City *',
  ProvinceLabel: 'Province/Territory *',
  PostalCodeLabel: 'Postal Code *',
  FirstNamePlaceholder: 'First name',
  LastNamePlaceholder: 'Last name',
  EmailPlaceholder: 'youremail@example.com',
  PhonePlaceholder: '(555) 555-5555',
  AddressPlaceholder: '123 Maple Street',
  CityPlaceholder: 'Springfield',
  PostalCodePlaceholder: 'A1A 1A1',
  Provinces: {
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NS: 'Nova Scotia',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    YT: 'Yukon',
  },
  Summary: {
    Title: 'Contact Summary:',
    Name: 'Name:',
    Email: 'Email:',
    Phone: 'Phone:',
    Address: 'Address:',
  },
};
